(function () {
  'use strict';

  var configElement = document.getElementById('Yfl17TrackTranslations');
  if (!configElement) return;

  var translations;
  try {
    translations = JSON.parse(configElement.textContent || '{}');
  } catch (error) {
    return;
  }

  if (!Object.keys(translations).length) return;

  var rootSelector = '#MainContent #__next';
  var queued = false;

  function translatedValue(value) {
    var normalized = String(value || '').trim();
    return Object.prototype.hasOwnProperty.call(translations, normalized)
      ? translations[normalized]
      : null;
  }

  function translateTextNode(node) {
    if (!node || !node.nodeValue) return;
    var normalized = node.nodeValue.trim();
    var translation = translatedValue(normalized);
    if (!translation || translation === normalized) return;
    node.nodeValue = node.nodeValue.replace(normalized, translation);
  }

  function translateAttributes(element) {
    ['placeholder', 'aria-label', 'title'].forEach(function (attribute) {
      if (!element.hasAttribute(attribute)) return;
      var current = element.getAttribute(attribute);
      var translation = translatedValue(current);
      if (translation && translation !== current) {
        element.setAttribute(attribute, translation);
      }
    });

    if (element instanceof HTMLInputElement && /^(button|submit)$/i.test(element.type)) {
      var valueTranslation = translatedValue(element.value);
      if (valueTranslation && valueTranslation !== element.value) {
        element.value = valueTranslation;
      }
    }
  }

  function translateRoot(root) {
    if (!root) return;

    if (root.nodeType === Node.ELEMENT_NODE) {
      translateAttributes(root);
    }

    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (node.nodeType === Node.TEXT_NODE) {
            var parent = node.parentElement;
            if (!parent || /^(SCRIPT|STYLE|NOSCRIPT)$/i.test(parent.tagName)) {
              return NodeFilter.FILTER_REJECT;
            }
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    var node = walker.currentNode;
    while (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        translateTextNode(node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        translateAttributes(node);
      }
      node = walker.nextNode();
    }
  }

  function translatePage() {
    queued = false;
    translateRoot(document.querySelector(rootSelector));
  }

  function queueTranslation() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(translatePage);
  }

  var mainContent = document.getElementById('MainContent');
  if (!mainContent) return;

  queueTranslation();

  var observer = new MutationObserver(queueTranslation);
  observer.observe(mainContent, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['placeholder', 'aria-label', 'title', 'value']
  });
})();
